module.exports = __webpack_public_path__ + "static/media/Cover-exp.33868d70.jpg";